import React, { Component } from 'react'
import HeatMapContainer from './HeatMapContainer'
import Header from './Header'
import Instructions from './Instructions'
import { withRouter } from "react-router"

export class Report extends Component {

  style = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      width: '8.5in',
      padding: '0.25in'
    },
  }

  render() {

    const { header, data, instructions } = this.props

    return (
      <div className="report no-break-print" style={ this.style.container }>

        <Header header={ header } />
        <HeatMapContainer data={ data } header={ header } />
        <Instructions instructions={ instructions } />

      </div>
    )
  }
}

export default withRouter(Report)